import {useEffect} from 'react'
import {useQuery} from 'react-query'
import {getInActiveCustomers} from '../services'
import useFilters from '../../../hook/useFilters'
import {dataToRecentlyInactiveCustomerListing} from '../utils'


export const useGetCustomersWithNoRecentOrders = (limit:number): any => {
  const initialFilters = {
    page: 1,
    limit: limit,
    sort_by: '',
  }
  const {filters, setSingleFilter ,setMultipleFilters} = useFilters(initialFilters)

  const {
    data: response,
    refetch,
    isFetching,
  } = useQuery(`customers-no-redent-${limit}-orders`, () => {
    return getInActiveCustomers(`/analytics/customers/no-recent-orders`, filters)
  })

  useEffect(() => {
    refetch()
  }, [filters, refetch])

  const onPageChange = (page_number: number) => {
    setSingleFilter('page', page_number)
  }

  const onClickSorting = (sortBy: string, sortDirection: any) => {
    const direction = sortDirection === 'asc' ? 1 : -1
    const sortFlag = sortBy + '/' + direction
    setMultipleFilters({
      sort_by: sortFlag,
      page: 1,
    })
  }

  return {
    recentlyInactiveCustomers: response?.data
      ? dataToRecentlyInactiveCustomerListing(response.data)
      : [],
    isLoading: isFetching,
    totalRecentlyInactiveCustomers:
      response?.meta?.pagination?.total || (response?.data ? response.data.length : 0),
    onPageChange,
    pagination: response?.['meta']?.['pagination'] || {},
    onRecentlyInactiveCustomerClickSorting: onClickSorting,
    RecentlyInactiveCustomerFilters: filters,
  }
}
